import { render } from "./QGift.vue?vue&type=template&id=2cadcca3"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QGift.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cadcca3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cadcca3', __exports__)) {
    api.reload('2cadcca3', __exports__)
  }
  
  module.hot.accept("./QGift.vue?vue&type=template&id=2cadcca3", () => {
    api.rerender('2cadcca3', render)
  })

}


export default __exports__